// Pass the chosen concept into the existing venue discovery form. No search or invitation is sent.
export const ideaDiscoveryPrefill = (idea) => ({
  free_text: [idea.title, idea.short_description, idea.concept].filter(Boolean).join(' — ').slice(0, 2000),
  event_type: idea.event_type || null,
  expected_attendees: idea.suggested_capacity || null,
  preferred_districts: [...(idea.suggested_districts || [])],
  preferred_days: [...(idea.preferred_days || [])],
  preferred_time_ranges: [...(idea.preferred_time_ranges || [])],
});
